import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { LockIcon } from 'lucide-react';
import { usePortalAuth } from '../../context/PortalAuth';
import { usePortalOrg } from '../../context/PortalOrg';
import { Button } from '../../components/ui/Button';

/**
 * Wraps every /portal/orgs/:orgId page. A link to an organisation the person
 * does not belong to gets the same neutral message as one that does not exist,
 * and the pages beneath never render.
 */
export function OrgScope() {
  const {
    orgId = ''
  } = useParams<{
    orgId: string;
  }>();
  const {
    roleIn
  } = usePortalAuth();
  const {
    orgId: activeOrg,
    setOrgId
  } = usePortalOrg();
  const role = roleIn(orgId);
  React.useEffect(() => {
    if (role && orgId !== activeOrg) setOrgId(orgId);
  }, [role, orgId, activeOrg, setOrgId]);
  if (!role) {
    return <div className="mx-auto max-w-lg py-16 text-center" data-id="element-2807" data-mp="1akjywk9722f5">
        <LockIcon className="mx-auto h-8 w-8 text-muted" aria-hidden="true" data-id="element-2808" data-mp="1fk4ymww6uesx" />
        <h1 className="mt-5 font-display text-[26px] text-ink" data-id="element-2809" data-mp="1fi1y3ixet39y">This page is not available</h1>
        <p className="mt-3 text-[15px] text-body" data-id="element-2810" data-mp="cxcq65iyjjg2">
          It may belong to an organisation you are not a member of. If you think you should have access, ask an owner or
          admin in that organisation to invite you.
        </p>
        <div className="mt-8" data-id="element-2811" data-mp="httmhn0b9448">
          <Button to="/portal/dashboard" variant="secondary" data-id="element-2812" data-mp="htlcc2vkocwq">
            Back to all engagements
          </Button>
        </div>
      </div>;
  }
  return <Outlet data-id="element-2813" data-mp="rsslsez6rnek" />;
}